module.exports = __webpack_public_path__ + "static/img/smartstation22.f30402d7.png";